import React from 'react';
import { RangeDisplayProps } from './type';
import { Box, Typography } from '@mui/material';
import { Button } from '@alifd/next';

const RangeDisplay: React.FC<RangeDisplayProps> = ({ ranges, setRanges }) => {
  const sortRanges = ranges.sort((a, b) => a[0].localeCompare(b[0]));
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        mt: '10px',
      }}
    >
      {sortRanges.map(([start, end], index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >{`${start} ~ ${end}`}</Typography>
          <Button
            onClick={() =>
              setRanges((prev) => prev.filter((_, i) => i !== index))
            }
            warning
          >
            刪除
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default RangeDisplay;
